import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { MessageSquareIcon, PlusIcon } from 'lucide-react';
const cases = [{
  id: 'CS-2026-001',
  supplier: 'Oceanic Harvest Pte Ltd',
  subject: 'Invoice payment inquiry',
  category: 'Finance',
  priority: 'Medium',
  status: 'Open',
  owner: 'Sarah Lim',
  age: '2 days'
}, {
  id: 'CS-2026-002',
  supplier: 'TechServe Asia',
  subject: 'Portal access issue',
  category: 'Technical',
  priority: 'High',
  status: 'In Progress',
  owner: 'IT Helpdesk',
  age: '1 day'
}];
export const CaseConsolePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('cases');
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-327">
      <PageHeader title="Cases & Communications" description="Manage supplier support tickets and communications." primaryAction={<Button leftIcon={<PlusIcon className="w-4 h-4" data-id="element-330" />} data-id="element-329">
            New Message
          </Button>} data-id="element-328" />

      <Card noPadding data-id="element-331">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-332">
          <Tabs tabs={[{
          id: 'cases',
          label: 'Support Cases'
        }, {
          id: 'messages',
          label: 'Messages'
        }, {
          id: 'campaigns',
          label: 'Campaigns'
        }, {
          id: 'templates',
          label: 'Templates'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-333" />
        </div>
        <div className="p-6" data-id="element-334">
          {activeTab === 'cases' && <DataTable data={cases} columns={[{
          header: 'Case ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-336">{row.id}</span>
        }, {
          header: 'Supplier',
          accessorKey: 'supplier'
        }, {
          header: 'Subject',
          accessorKey: 'subject'
        }, {
          header: 'Category',
          accessorKey: 'category'
        }, {
          header: 'Priority',
          accessorKey: 'priority'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-337" />
        }, {
          header: 'Owner',
          accessorKey: 'owner'
        }, {
          header: 'Age',
          accessorKey: 'age'
        }]} data-id="element-335" />}
          {activeTab !== 'cases' && <div className="py-8 text-center text-text-secondary" data-id="element-338">
              <MessageSquareIcon className="w-12 h-12 mx-auto mb-4 text-border-strong" data-id="element-339" />
              <p data-id="element-340">
                Select a case to view details or switch tabs to manage campaigns
                and templates.
              </p>
            </div>}
        </div>
      </Card>
    </div>;
};